import React from "react";
import { Link } from "react-router-dom";
import ThemeLogo from "components/ThemeLogo";
import { getFallbackLogo } from "utilities/getFallbackLogo";

export default function NewTopHeader() {
  return (
    <nav className="navbar navbar-expand-lg bg-white w-100 shadow-sm">
      <div className="container-fluid px-3">
        <Link
          to="/"
          className="navbar-brand d-flex align-items-center text-decoration-none"
        >
          <ThemeLogo fallbackSrc={getFallbackLogo()} alt="Company logo" className="appLogo" />
        </Link>
      </div>
    </nav>
  );
}
